import { FuelCurveRow } from "../models/calculators.models";

interface FuelCurveTableProps {
  title: string;
  rows: FuelCurveRow[];
  dataTest: string;
  highlightedSpeeds: number[];
}

const FuelCurveTable = ({ title, rows, dataTest, highlightedSpeeds }: FuelCurveTableProps) => (
  <div data-test={dataTest} className="min-w-0 border border-gray-900 bg-white dark:bg-gray-900">
    <div className="border-b border-gray-300 py-1 text-center text-sm font-medium dark:border-gray-700">{title}</div>
    <div className="max-h-[270px] overflow-auto px-2">
      <table className="w-full text-right text-[11px] tabular-nums">
        <thead className="sticky top-0 bg-white dark:bg-gray-900">
          <tr className="border-b border-gray-300 dark:border-gray-700">
            <th className="py-1 text-left font-medium">Speed Ref</th>
            <th className="py-1 font-medium">ME Cons</th>
            <th className="py-1 font-medium">AE Cons</th>
            <th className="py-1 font-medium">Total Cons</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.speedRef}
              className={
                highlightedSpeeds.some((speed) => Math.abs(speed - row.speedRef) < 0.001)
                  ? "border-b border-gray-100 bg-[#E2EFDA] text-gray-950"
                  : "border-b border-gray-100 dark:border-gray-800"
              }
            >
              <td className="py-0.5 text-left">{row.speedRef.toFixed(1)}</td>
              <td>{row.meConsumption.toFixed(1)}</td>
              <td>{row.aeConsumption.toFixed(1)}</td>
              <td>{row.totalConsumption.toFixed(1)}</td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={4} className="py-10 text-center text-gray-500">Calculate to populate the curve.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default FuelCurveTable;
